exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.www {\r\n  /* margin: auto; */\r\n  text-align: center;\r\n  margin-top: 10%;\n}\r\n", ""]);

